var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.889 9.333a.458.458 0 01-.315-.124L.13 4.967a.412.412 0 010-.6L4.574.123a.46.46 0 01.63 0 .412.412 0 010 .6L1.072 4.668l4.13 3.942a.412.412 0 010 .6.458.458 0 01-.314.124z",
    fill: "#000"
  })));
}
SvgBackArrow.displayName = 'BackArrow';
export default SvgBackArrow;